// extracted by mini-css-extract-plugin
export default {"full_width":"LWDetailsModal_full_width__6EQsB"};